import React from 'react';
import {
    TextInput,
    DateInput,
    SimpleForm,
    Edit,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton, 
    BooleanInput,
    FormDataConsumer ,
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode';
import ErrorBoundary from '../../ErrorBoundary';

var role = (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).role : ''): '';
var level =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).level : ''): '';
var loc= (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).location : ''): '';
var ins_id= null;


export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none' 
     },
     inputStyle : {
         width :'20px',
     },
     controlInputStyle : {
        width :'70px',
        fontSize: '8'
    },
     labelStyle : {
        width :'40px',
        backgroundColor: 'silver'
    },
    iniLabelStyle : {
        width :'20px',
        backgroundColor: 'silver'
    },
    dateStyle : {
        width: '120px',
        
    },
    tableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'1px solid  black', 
        width: "100%"
    },
    h3: {
        textAlign: 'center',
        width: '100%'
    },
    clearTableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'0px solid  black', 
        width: "100%"
    },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },

 };
 
 const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const UserEditActions = ({ basePath}) => (
    <CardActions style={cardActionStyle}>
    <ListButton basePath={'/cal_STOP_WATCH_a?filter=%7B"ins_id"%3A"' + ins_id +'"%7D&order=DESC&page=1&perPage=25&sort=id'} />
</CardActions>
);

const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect={'/cal_STOP_WATCH_a?filter=%7B"ins_id"%3A"' + ins_id +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const IsPass = [
    {
        id: 'P',
        name: 'Pass'
    },
    {
        id: 'F',
        name: 'Fail'
    }
]

const GetInsID = ({record})=> (
    console.log(record),
    ins_id  = (record && record.ins_id)? record.ins_id:ins_id
)

const InstEdit = ({classes, ...props }) => (
<ErrorBoundary>     
    <Edit actions={<UserEditActions />}   {...props}  title="Edit user">
        <SimpleForm toolbar={<UserCreateToolbar />} >
        <GetInsID props ={props} />
            <table className={classes.clearTableStyle}>
                <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>STOP WATCH</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextInput source='center'  label='' defaultValue={loc} /></td>
                        <td>Equipment ID:</td><td><TextInput source='ins_id'  label='' /></td>
                    </tr>
                    <tr>
                        <td>Master clock Start Time:</td><td><TextInput source='st_time' label='hr:min:sec' /></td>
                        <td>Mater Clock Stop Time:</td><td><TextInput source='sp_time' label='hr:min:sec' /></td>
                    </tr>
                    <tr>
                        <td>Master Clock Total Time Elapsed:</td><td><TextInput source='m_el' label='min:sec' /></td>
                        <td>Stopwatch Total Time Elapsed:</td><td><TextInput source='s_el' label='min:sec' /></td>
                    </tr>
                    <tr>
                        <td>Variance:</td><td><TextInput source='variance' label='seconds' /></td>
                        <td>Pass/Fail:</td><td><SelectInput source='is_pass' choices={IsPass} label='' /></td>
                    </tr>
                    <tr>
                        <td>Tech Initial:</td><td><TextInput source='tech_init' label='' /></td>
                        <td>Tech Date:</td><td><DateInput source='tech_date' label='' locales='en-us' /></td>
                    </tr>
                    <FormDataConsumer>
                    {({
                        formData, // The whole form data
                        scopedFormData, // The data for this item of the ArrayInput
                        getSource, // A function to get the valid source inside an ArrayInput
                        ...rest
                    }) =>
                        ( role==='QA' || role==='Admin' || level > 6 )? (
                        <>
                        <tr > 
                            <td>QA Initial:</td><td><TextInput source='qa_init' label='' /></td>
                            <td>QA Date:</td><td><DateInput source='qa_date' label='' locales='en-us' /></td>
                        </tr>
                        <tr>
                            <td><BooleanInput source='is_qa' label='Is QA Approved?' /></td>
                        </tr>
                        </>
                    ):''
                        }
                    </FormDataConsumer>
                </tbody>
            </table>
        </SimpleForm>        
    </Edit>
    </ErrorBoundary>  
);

export default withStyles(styles) (InstEdit);
